<div class="settings-box-shadow">
  <h3 class="no-left-margin">FlyCut <span class="font-weight-bold">Timeout</span></h3>
  <p>
    Control how patient FlyMSG is while you type a completed FlyCut (aka shortcut). If sometimes, your FlyCuts do
    not complete for you (meaning actually expand once you type out the shortcut), you type slower or your using a
    long FlyCut; try increasing this value below. For example: imagine if you had a FlyCut no-op, if you then type
    No and wait longer than the FlyCut timeout before typing -op, it will allow you to type it without triggering
    the expansion. The default is 5000 ms.
  </p>

  <vng-card variant="ghost" padding="none" [formGroup]="form">
    <div>
      <!-- v19.7 vng-range-slider replaces the native range input + appCustomRangeSlider
           directive (both deleted). The component ships its own track/thumb styling and
           binds --value-percent itself; the thumbLabel bubble is gone, and the persistent
           ms readout below reproduces it. -->
      <vng-range-slider
        class="w-100"
        [min]="250"
        [max]="10000"
        [step]="50"
        ariaLabel="FlyCut timeout"
        formControlName="timeout"
      ></vng-range-slider>

      <div class="range-info">{{ timeout }}ms</div>
    </div>
    <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px" class="settings-card-actions">
      <button
        type="button"
        vng-button
        variant="secondary"
        [disabled]="timeout == 5000"
        (click)="setDefault()"
        tabindex="-1"
      >
        Set Default
      </button>
      <button
        type="button"
        vng-button
        variant="primary"
        [disabled]="!isDirty || isSaving"
        (click)="save()"
        tabindex="-1"
      >
        Save
      </button>
    </div>
  </vng-card>
</div>
